import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';

export type QuillAttachmentSource = 'device' | 'library';

@Component({
  selector: 'app-quill-attachment-source-picker',
  standalone: true,
  imports: [MatMenuModule, TranslateModule],
  template: `
    <div class="quill-attachment-source-picker">
      <button type="button" mat-menu-item (click)="select('device')">
        {{ 'Attachments.library.fromDevice' | translate }}
      </button>
      <button type="button" mat-menu-item (click)="select('library')">
        {{ 'Attachments.library.fromDocuments' | translate }}
      </button>
    </div>
  `,
  styles: [
    `
      .quill-attachment-source-picker {
        display: grid;
        min-width: 276px;
        padding: 10px;
        border: 1px solid #ebf2f8;
        border-radius: 8px;
        background: #fff;
        box-shadow: 0 4px 21px rgba(0, 0, 0, 0.25);
      }
      .quill-attachment-source-picker button {
        width: 100%;
        min-height: 34px;
        padding: 0 14px 0 6px;
        color: #1b2129;
        font-family: Inter, sans-serif;
        font-size: 14px;
        font-style: normal;
        line-height: 24px;
      }
      .quill-attachment-source-picker button:hover {
        border-radius: 4px;
        background: rgba(86, 116, 246, 0.1);
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuillAttachmentSourcePickerComponent {
  readonly sourceSelected = output<QuillAttachmentSource>();

  protected select(source: QuillAttachmentSource): void {
    this.sourceSelected.emit(source);
  }
}
